import Reservation from "@components/Reservation";
import { useProfileReservationsQuery } from "@graphql/api";
import ConcentricLoader from "@hudson/ui/components/Loader/ConcentricLoader";
import Session from "@lib/session";
import useContent from "@lib/use_content";
import readRes from "@services/read_res";
import useWindowSize from "@utils/use_window_size";
import { useState } from "react";
import NoReservations from "./NoReservations";

interface ReservationListProps {
  dateRange?: be.ProfileReservationDateRange;
  onPageChange: (page: string) => void;
  profileId: number;
}

export default function ReservationList({
  dateRange = "future",
  onPageChange,
  profileId,
}: ReservationListProps) {
  const { data } = useContent([
    "beProfileResViewDetailsButton",
    "beProfileResViewDetailsOpenButton",
  ]);
  const [loading, setLoading] = useState<number>();
  const {
    data: resData,
    loading: resLoading,
    error,
  } = useProfileReservationsQuery({
    variables: { dateRange },
  });

  const [size] = useWindowSize();

  if (error) {
    console.error(error);
    return null;
  }

  async function viewDetails(resId: number) {
    if (!resId) return;

    setLoading(resId);

    let booking = await readRes({ resId });
    setLoading(undefined);
    if (booking) {
      booking.flags = { ...booking.flags, keepUserLoggedIn: true };
      Session.setVerifiedBooking(booking);
      onPageChange("res_summary");
    }
  }

  return resLoading ? (
    <ConcentricLoader className="opacity-60 max-w-2xl mx-auto px-4 sm:py-10 sm:px-6 lg:px-8" />
  ) : (
    <div className="flex flex-col gap-y-8 mt-8" key={dateRange}>
      {!resLoading && resData?.profileReservations?.length == 0 ? (
        <NoReservations />
      ) : (
        resData?.profileReservations?.map((res) => 
          res ? (
            <div
              className="border-b-4 relative bg-gray-50 px-2 xs:px-4 py-4 rounded-2xl shadow-sm"
              key={res.id}
            >
              <Reservation
                key={res.id}
                res={res}
                vertical={size < 640}
                actions={[
                  {
                    label: res.service?.selectedTime?.pickupTime
                      ? data?.content.beProfileResViewDetailsButton || ""
                      : data?.content.beProfileResViewDetailsOpenButton || "",
                    disabled: !!(loading && res.resIdInternal != loading),
                    loading: res.resIdInternal == loading,
                    onClick: () => viewDetails(parseInt(res.id)),
                  },
                ]}
                compact
                hideLocationString
              />
            </div>
          ) : null
        )
      )}
    </div>
  );
}
